import { m as meaninglessTransform } from './meaninglessTransform-DIm6EBap.js';

/** Returns if the given transform object contains any non-default values */
const transformIsMeaningful = transform => transform.size !== meaninglessTransform.size || transform.x !== meaninglessTransform.x || transform.y !== meaninglessTransform.y || transform.rotate !== meaninglessTransform.rotate || transform.flipX || transform.flipY;

export { transformIsMeaningful as t };
//# sourceMappingURL=transformIsMeaningful-CVfQREwW.js.map
